import React, { useState } from "react";
import styles from "./GroupedEventItem.module.css";
import { ActionableInvite, DigestItem as DigestItemType, InviteStatus } from "../../gql/types";
import PlaydateInvitationCard from "../playdate/PlaydateInvitationCard";
import UnderlineButton from "../button/UnderlineButton";
import PlaydateInviteRecipientReviewWorkflow from "../playdate/workflow/recipient/review/PlaydateInviteRecipientReviewWorkflow";
import PlaydateInvitationResponseCard from "../playdate/PlaydateInvitationResponseCard";
import PlaydateInviteOrganizerReviewWorkflow from "components/playdate/workflow/PlaydateInviteOrganizerReviewWorkflow";
import { useToastContext } from "contexts/ToastContext";

type ActionableInviteItemProps = {
    item: DigestItemType;
};

const ActionableInviteItem: React.FC<ActionableInviteItemProps> = ({ item }) => {
    const actionableInvite = item.content as ActionableInvite;
    const currentInvite = actionableInvite.invite;

    const isRecipient = currentInvite.guestUpdate && currentInvite.guestUpdate !== null;

    const [showWorkflowOrBackCard, setShowWorkflowOrBackCard] = useState(false);
    const { triggerToastEvent } = useToastContext();

    if (currentInvite === null) {
        return <></>;
    }

    const hasResponseOrSuggestedResponse = currentInvite.viewerResponse || (actionableInvite.suggestion &&
        actionableInvite.suggestion !== null &&
        actionableInvite.suggestion.scheduleSuggestion);

    const hasBack = hasResponseOrSuggestedResponse && isRecipient;

    const recipientHeaderElement = (
        <UnderlineButton
            textSize="small"
            onClick={() => setShowWorkflowOrBackCard(true)}
        >
            {actionableInvite.invite.viewerResponse ? "Change Your RSVP" : "Respond to Invite"}
        </UnderlineButton>
    )

    const organizerHeaderElement = (
        <UnderlineButton
            textSize="small"
            onClick={() => setShowWorkflowOrBackCard(true)}
        >
            {currentInvite.status === InviteStatus.InPlanning ? "Finalize Invite" : "View Details"}
        </UnderlineButton>
    )

    if ((!currentInvite.guestUpdate || currentInvite.guestUpdate === null) &&
        (!currentInvite.organizerUpdate || currentInvite.organizerUpdate === null)) {
        return <></>;
    }

    return (
        <>
            <div className={`${styles.digestItem}`}>
                <div className={styles.cardFlipContainer}>
                    <div className={`${hasBack ? styles.cardFlipper : ''} ${hasBack && showWorkflowOrBackCard ? styles.flipped : ""}`}>
                        <div className={`${hasBack ? styles.front : ''}`}>
                            <PlaydateInvitationCard
                                invite={currentInvite}
                                onBack={() => { }}
                                disableBottomDetails={true}
                                headerElement={isRecipient ? recipientHeaderElement : organizerHeaderElement}
                            />
                        </div>
                        {isRecipient && hasBack && <div className={styles.back}>
                            <PlaydateInvitationResponseCard
                                invite={currentInvite}
                                onDataChange={(success, updatedInvite) => {
                                    if (success) {
                                        triggerToastEvent();
                                    }
                                    setShowWorkflowOrBackCard(false);
                                }}
                                suggestion={actionableInvite.suggestion ?? (actionableInvite.suggestion !== null ? actionableInvite.suggestion : undefined)}
                            />
                        </div>}
                    </div>
                </div>
            </div>
            {showWorkflowOrBackCard && isRecipient && !hasResponseOrSuggestedResponse && <PlaydateInviteRecipientReviewWorkflow
                invite={currentInvite}
                onBack={() => setShowWorkflowOrBackCard(false)}
                onDataChange={(success, updatedInvite) => {
                    if (success) {
                        triggerToastEvent();
                    }
                    setShowWorkflowOrBackCard(false);
                }}
            />}
            {showWorkflowOrBackCard && !isRecipient && <PlaydateInviteOrganizerReviewWorkflow
                invite={currentInvite}
                onBack={() => setShowWorkflowOrBackCard(false)}
                onDataChange={(success, updatedInvite) => {
                    if (success) {
                        triggerToastEvent();
                    }
                    setShowWorkflowOrBackCard(false);
                }}
            />}
        </>
    );
};

export default ActionableInviteItem;
